export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CORS_ANYWHERE_PROXY = process.env.REACT_APP_CORS_ANYWHERE_PROXY;
export const LOCATION_IQ_KEY = process.env.REACT_APP_LOCATION_IQ_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
